import { buildLSWHPrompt, buildSubjectsPrompt } from "./aiPrompts";

const LSWH_CHAR_LIMIT = 2000;
const SUBJECTS_CHAR_LIMIT = 2000;

export const LSWH_CONFIG = {
  systemPrompt: buildLSWHPrompt(LSWH_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    daysAbsent: v.daysAbsent,
    timesLate: v.timesLate,
    responsibility: v.responsibility,
    organization: v.organization,
    independentWork: v.independentWork,
    collaboration: v.collaboration,
    initiative: v.initiative,
    selfRegulation: v.selfRegulation,
  }),
};

export const SUBJECTS_CONFIG = {
  systemPrompt: buildSubjectsPrompt(SUBJECTS_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
  }),
};
